import { render, staticRenderFns } from "./DrinksPage.vue?vue&type=template&id=377528c0&scoped=true&"
import script from "./DrinksPage.vue?vue&type=script&lang=js&"
export * from "./DrinksPage.vue?vue&type=script&lang=js&"
import style0 from "./DrinksPage.vue?vue&type=style&index=0&id=377528c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377528c0",
  null
  
)

export default component.exports